import React from "react";

import farm1 from "./farm1.jpeg";
import farm2 from "./farm2.jpeg";
import farm3 from "./farm3.jpeg";
import farm4 from "./farm4.jpeg";
import farm5 from "./farm5.jpg";
import farm6 from "./farm6.jpeg";
import farm7 from "./farm7.jpeg";
import farm8 from "./farm8.jpeg";
import farm9 from "./farm9.jpeg";
import farm10 from "./farm10.jpeg";


import productImage from "./WhatsApp Image 2025-12-22 at 11.27.57 PM (1) (1).png";


function Farm() {
  return (
    <>
      <head>
        <title>OM Agro Foods | Mango Pulp Manufacturer & Exporter | Gir</title>

        <meta
          name="description"
          content="OM AGRO FOODS offers premium quality Kesar Mango Pulp made from handpicked mangoes. Ideal for aamras, ice creams, desserts, beverages, and bulk supply."
        />

        <meta
          name="keywords"
          content="Kesar Mango Pulp, om agro food farm, mango collecting, Mango Pulp Manufacturer, Mango Pulp Supplier, OM AGRO FOODS, om agro foods, natural mango pulp, mango pulp, Aamras Pulp, Bulk Mango Pulp"
        />

        <link rel="canonical" href="https://omagrofoods.vercel.app/" />

        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="48x48" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="96x96" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="192x192" />
        <link rel="shortcut icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <link rel="apple-touch-icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <meta property="og:title" content="OM AGRO FOODS | Premium Kesar Mango Pulp" />
        <meta
          property="og:description"
          content="Premium quality Kesar Mango Pulp with rich taste, aroma, and natural sweetness. Available for retail and bulk orders."
        />
        <meta property="og:image" content={productImage} />
        <meta property="og:url" content="https://omagrofoods.vercel.app/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="OM AGRO FOODS | Premium Mango Pulp" />
        <meta
          name="twitter:description"
          content="Premium Kesar Mango Pulp supplier for homes, hotels, and food industries."
        />
        <meta name="twitter:image" content={productImage} />
      </head>

    
    <div className="farm-container">

      <div className="farm-header">
        <h1>Our Mango Farms</h1>
        <p>
          From fertile land to fresh harvest — discover how we grow
          premium-quality mangoes with care, tradition, and sustainability.
        </p>
      </div>

      <div className="farm-about">
        <h2>About Our Farms</h2>
        <p>
          Our mango farms are located in carefully selected regions of India
          known for rich soil, favorable climate, and ideal growing conditions.
          We combine traditional farming wisdom with modern agricultural
          practices to ensure healthy mango trees and superior fruit quality.
        </p>

        <p>
          Every stage — from plantation to harvesting — is closely monitored
          to maintain natural taste, aroma, and nutritional value.
        </p>
      </div>

      <div className="farm-gallery">
        <h2>Our Farm Gallery</h2>

          <div className="farm-images">
            <img src={farm1} alt="Mango Farm View" />
            <img src={farm2} alt="Mango Trees" />
            <img src={farm3} alt="Mango Harvesting" />
            <img src={farm4} alt="Fresh Mangoes" />
            <img src={farm5} alt="Fresh Mangoes" />
            <img src={farm6} alt="Fresh Mangoess" />
            <img src={farm7} alt="Fresh Mangoess" />
            <img src={farm8} alt="Fresh Mangoess" />
            <img src={farm9} alt="Fresh Mangoess" />
            <img src={farm10} alt="Fresh Mangoess" />
          </div>
      </div>

      <div className="farm-highlights">
        <h2>Farm Highlights</h2>

        <div className="highlights-grid">
          <div className="highlight-card">Natural & Fertile Soil</div>
          <div className="highlight-card">Experienced Farmers</div>
          <div className="highlight-card">Eco-Friendly Farming</div>
          <div className="highlight-card">Hand-Picked Harvesting</div>
          <div className="highlight-card">Quality-Controlled Process</div>
          <div className="highlight-card">Sustainable Water Management</div>
        </div>
      </div>

      <div className="farm-practices">
        <h2>Our Farming Practices</h2>
        <ul>
          <li>Careful selection of mango varieties</li>
          <li>Minimal use of chemicals</li>
          <li>Natural ripening process</li>
          <li>Strict hygiene during harvesting</li>
          <li>Direct supply from farm to processing unit</li>
        </ul>
      </div>

    </div>
    </>
  );
}

export default Farm;
